import api from "lib/api";

// Tamanho de cada lote do resultado da busca por selfie (o teto do backend).
export const SEARCH_PAGE_SIZE = 200;

/**
 * Resultado COMPLETO de uma busca por selfie.
 *
 * A API pagina o resultado (`count` = total, `results` = o lote). A tela mostra
 * tudo — o mesmo total que o cartao de compartilhamento anuncia —, entao os
 * lotes seguintes sao buscados pelo id da busca ate cobrir o `count`.
 * `first` e a resposta ja recebida (do POST da busca ou do GET do link).
 */
export async function completeSearchResults(first) {
  let results = first?.results || [];
  const total = first?.count ?? results.length;
  const searchId = first?.search_id;
  while (searchId && results.length < total) {
    const res = await api.get(`/api/public/face-searches/${searchId}/`, {
      params: { offset: results.length, limit: SEARCH_PAGE_SIZE },
    });
    const batch = res.data?.results || [];
    if (!batch.length) break; // o acervo mudou entre um lote e outro
    results = results.concat(batch);
  }
  return results;
}
